module.exports = __webpack_public_path__ + "img/icon-konsultasi.224b717d.svg";